// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomDateRangePicker_wrapper__zc475","customDay":"CustomDateRangePicker_customDay__FPtks"};